// extracted by mini-css-extract-plugin
export default {"App":"layout_rem_App__fMYI7"};